/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Move_Line_UpInputs */

const en_shortcut_keys_desc_move_line_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shift line backwards to the end of the previous Event`)
};

const fr_shortcut_keys_desc_move_line_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer une ligne vers la fin de l'evenement precedent`)
};

const de_shortcut_keys_desc_move_line_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschiebe die Zeile zurück zum Ende des vorherigen Ereignisses`)
};

const it_shortcut_keys_desc_move_line_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta la riga indietro fino alla fine dell'evento precedente`)
};

const ru_shortcut_keys_desc_move_line_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сдвиньте линию назад к концу предыдущего события.`)
};

const es_shortcut_keys_desc_move_line_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazar la línea hacia atrás hasta el final del evento anterior`)
};

const zh_cn2_shortcut_keys_desc_move_line_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将行向后移动到上一个事件的末尾`)
};

const ja_shortcut_keys_desc_move_line_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行を前のイベントの最後へ移動します`)
};

const hi_shortcut_keys_desc_move_line_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइन को पीछे की ओर खिसकाकर पिछली घटना के अंत तक ले जाएं।`)
};

const pt_pt2_shortcut_keys_desc_move_line_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desloque a linha para trás até o final do evento anterior.`)
};

/**
* | output |
* | --- |
* | "Shift line backwards to the end of the previous Event" |
*
* @param {Shortcut_Keys_Desc_Move_Line_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_move_line_up = /** @type {((inputs?: Shortcut_Keys_Desc_Move_Line_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Move_Line_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_move_line_up(inputs)
	if (locale === "de") return de_shortcut_keys_desc_move_line_up(inputs)
	if (locale === "it") return it_shortcut_keys_desc_move_line_up(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_move_line_up(inputs)
	if (locale === "es") return es_shortcut_keys_desc_move_line_up(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_move_line_up(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_move_line_up(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_move_line_up(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_move_line_up(inputs)
	return en_shortcut_keys_desc_move_line_up(inputs)
});